import { useEffect } from 'react';
import Navbar from './components/Navbar';
import FloatingBanner from './components/FloatingBanner';
import HeroSection from './components/HeroSection';
import TeamSection from './components/TeamSection';
import CommitmentSection from './components/CommitmentSection';
import EvidenceSection from './components/EvidenceSection';
import InfographicSection from './components/InfographicSection';
import FooterSection from './components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://tevanashi.com';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'TEVANASHI',
  alternateName: 'The All-Star Partner',
  url: SITE_URL,
  description:
    '美容師・マーケター・ECスペシャリスト・AIコンサル・補助金コンサルタント・デザイナーが並走する事業支援チーム。累計20億EC実績、ランキング1位900冠。',
  sameAs: [],
};

const webSiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'TEVANASHI',
  url: SITE_URL,
  description:
    '最強の専門家チームが並走する事業支援。立ち上げから成長まで逃げない実戦集団TEVANASHI。',
  inLanguage: 'ja',
};

const professionalServiceSchema = {
  '@context': 'https://schema.org',
  '@type': 'ProfessionalService',
  name: 'TEVANASHI - The All-Star Partner',
  url: SITE_URL,
  description:
    '美容師・マーケター・ECスペシャリスト・AIコンサル・補助金コンサルタント・デザイナーが並走。累計20億EC実績、ランキング1位900冠。立ち上げから成長まで逃げない実戦集団。',
  serviceType: '事業支援・コンサルティング',
  areaServed: {
    '@type': 'Country',
    name: '日本',
  },
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: 'TEVANASHI サービス一覧',
    itemListElement: [
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '美容師コンサルティング', description: '21年間の現場経験から培った顧客心理の深い洞察' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ECマーケティング支援', description: 'EC売上20億円、ランキング900冠以上の実績' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'AIコンサルティング', description: 'バックオフィス自動化・業務効率化' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: '補助金・助成金コンサルティング', description: '補助金・助成金の活用から戦略策定まで' } },
      { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'ブランドデザイン', description: 'ブランドの世界観を視覚言語に変換' } },
    ],
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'TEVANASHIはどのような事業支援を提供していますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '美容師・マーケター・ECスペシャリスト・AIコンサル・補助金コンサルタント・デザイナーの7つの専門家が1つのパッケージで並走します。立ち上げから成長まで一貫してサポートします。',
      },
    },
    {
      '@type': 'Question',
      name: 'TEVANASHIの実績はどのくらいですか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '累計EC売上20億円以上、ランキング1位900冠以上、商品開発実績30件以上の実績があります。',
      },
    },
    {
      '@type': 'Question',
      name: 'どのように相談できますか？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'ページ内の「無料相談を予約する」ボタンからお問い合わせいただけます。まずはお気軽にご相談ください。',
      },
    },
  ],
};

function injectJsonLd(id: string, data: object) {
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('script');
    el.id = id;
    (el as HTMLScriptElement).type = 'application/ld+json';
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function HomePage() {
  useEffect(() => {
    injectJsonLd('schema-organization', organizationSchema);
    injectJsonLd('schema-website', webSiteSchema);
    injectJsonLd('schema-professional-service', professionalServiceSchema);
    injectJsonLd('schema-faq', faqSchema);
  }, []);

  return (
    <div className="bg-[#080808] min-h-screen">
      <Navbar />
      <FloatingBanner />
      <main>
        <HeroSection />
        <TeamSection />
        <CommitmentSection />
        <EvidenceSection />
        <InfographicSection />
      </main>
      <FooterSection />
    </div>
  );
}
